module.exports = __webpack_public_path__ + "static/media/5.4127e3f1.jpg";